import { IolmKitModel } from "apps/schedule/src/app/core/models/revision/iolm-kit.model";
import { CampaignModel } from "../../../../core/models/campaigns/campaign.model";
import { ScheduleServices } from "../../../../core/models/schedule/schedule-services.model";

export class SubtotalModel {
  "revisionExists" = false;
  "servicesExists" = false;
  "iolmExists" = false;
  "services": ScheduleServices[] = [];
  "iolmKit": IolmKitModel[] = [];
  "deliveryExists" = false;
  "revisionInitialPrice" = 0;
  "revisionPrice" = 0;
  "servicesTotalPrice" = 0;
  "iolmTotalPrice" = 0;
  "deliveryPrice" = 0;
  "deliveryPromotionalPrice": number | undefined = 0;
  "deliveryFinalPrice" = 0;
  "revisionHasPromotion" = false;
  "servicesHasPromotion" = false;
  "fordProtectExists" = false;
  "revisionPromotionalPrice" = 0;
  "servicesTotalPromotionalPrice" = 0;
  "revisionPromotionName" = '';
  "revisionPromotionPercent" = 0;
  "servicesPromotionPercent" = 0;
  "servicesOnRequest" = false;
  "servicesPromotionName" = '';
  "revisionFinalPrice" = 0;
  "servicesFinalPrice" = 0;
  "iolmFinalPrice" = 0;
  "campaing": CampaignModel[] = [];
  "washService" = false;
  "totalPrice" = 0;
}
